import { Box, Text, Stack, Flex } from '@instamenu/ui-system-next';
import { palette } from '@instamenu/ui-vanilla-extract';
import * as styles from './delivery-tracker.css';
import { deliveryStatusMap, getStepIcon } from './status-map';
import { dateFormats, formatDate } from '@instamenu/formatters';
import { DeliveryStatus, OrderStatus } from '@instamenu/data-access';
import { Order } from '@instamenu/context-checkout';

type DeliveryStepProps = {
  step: OrderStatus | DeliveryStatus;
  isActive: boolean;
  isCompleted: boolean;
  delivery?: Order['delivery'];
};

export const DeliveryStep = ({ step, isActive, isCompleted, delivery }: DeliveryStepProps) => {
  const { description } =
    step === OrderStatus.Placed
      ? deliveryStatusMap(OrderStatus.Placed)
      : deliveryStatusMap(OrderStatus.Accepted, step as DeliveryStatus);

  const showEta =
    isActive &&
    [DeliveryStatus.PickupEnroute, DeliveryStatus.AtPickup, DeliveryStatus.DropoffEnroute].includes(
      step as DeliveryStatus,
    );
  const etaTime =
    step === DeliveryStatus.DropoffEnroute ? delivery?.dropoffEtaAt : delivery?.pickupEtaAt;
  const etaLabel = step === DeliveryStatus.DropoffEnroute ? 'Delivery ETA' : 'Pickup ETA';

  return (
    <Flex className={styles.stepStack}>
      <Box
        className={styles.stepIndicatorStyle}
        data-active={isActive}
        data-completed={isCompleted}
      >
        {getStepIcon(step, isActive, isCompleted)}
      </Box>
      <Stack className={styles.stepContentStack}>
        <Text
          variant="caption2"
          css={{
            // Active gets full color + bolder weight; completed steps drop a
            // shade so the eye reads them as "in the past"; upcoming go
            // lighter still.
            color: isActive ? palette.gray900 : isCompleted ? palette.gray700 : palette.gray400,
            fontSize: isActive ? '14px' : '13px',
            fontWeight: isActive ? 600 : 400,
            textAlign: 'left',
            transition: 'color 0.3s ease, font-weight 0.3s ease, font-size 0.3s ease',
          }}
        >
          {description}
          {showEta && etaTime && (
            <Text variant="caption2" css={{ color: palette.gray700 }}>
              {etaLabel} at {formatDate(etaTime, dateFormats.timeOnly)}
            </Text>
          )}
        </Text>
      </Stack>
    </Flex>
  );
};
